import { useUser } from 'hooks/useUser';

export const useUserPartnerCode = () => {
  const user = useUser();

  if (user?.partnerCode) {
    return user.partnerCode;
  }

  return '';
};
